export default __webpack_public_path__ + "static/media/four.18286314.jpg";